import {
  FilterOption,
  HandleSelect,
  MetadataType,
  SetStateFunction,
  SingleExportItem,
} from "types";
import { ImageFileCard } from "../ImageFileCard";
import { State } from "redux/store";
import { connect, useDispatch } from "react-redux";
import { getSimilarityVertexCluster } from "redux/SingleDataset/selectors";
import { useParams, useSearchParams } from "react-router-dom";
import { DATA_PAGE } from "helpers/constants/pages";
import { MouseEvent, useCallback } from "react";
import {
  setCardslistLoading,
  setNavigationCluster,
  setNavigationClusterLoader,
  setSimilarityVertex,
} from "redux/SingleDataset/actions";
import {
  AUTOMATIC_FLAT_RESPONSE_PARAMETER,
  PAGE_PARAMETER,
  VERTEX_CONTEXT,
  VERTEX_ID,
  VERTEX_SIMILARITY,
  VERTEX_TYPE,
} from "helpers/constants/miscellaneous";
import EnrichmentCard from "../EnrichmentCard";
import useQueryParam from "hooks/useQueryParam";

interface VertexCardProps {
  index: number;
  vertexCluster: any;
  cardElementRef?: any;
  cardContainerRef: any;
  indexOfPointerOut: number;
  showMetadataSummary: boolean;

  clusters: any;
  showDebugInfo: boolean;
  isCardslistLoading: boolean;
  exportData: SingleExportItem[];
  datasetLabels?: FilterOption[];
  datasetUserTags?: FilterOption[];
  relevanceScores?: number[] | null;
  isNavigationClusterLoading: boolean;

  onSelect: HandleSelect;
  onIndexOfPointerOut: SetStateFunction<number>;

  //enrichment
  globalMDType: MetadataType;
  onGlobalMDTypeChange: (type: MetadataType) => void;
}

const VertexCard = ({
  index,
  globalMDType,
  vertexCluster,
  cardElementRef,
  cardContainerRef,
  indexOfPointerOut,
  showMetadataSummary,

  clusters,
  exportData,
  showDebugInfo,
  datasetLabels,
  datasetUserTags,
  relevanceScores,
  isCardslistLoading,
  isNavigationClusterLoading,

  onSelect,
  onIndexOfPointerOut,
  onGlobalMDTypeChange,
}: VertexCardProps) => {
  const { datasetId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const vertexType = useQueryParam(VERTEX_TYPE);
  const dispatch = useDispatch();

  const handleRemoveVertex = (e: MouseEvent) => {
    e.stopPropagation();

    dispatch(setNavigationClusterLoader(true));
    dispatch(setCardslistLoading(true));
    dispatch(setNavigationCluster(null));
    dispatch(setSimilarityVertex(null));

    searchParams.delete(VERTEX_ID);
    searchParams.delete(VERTEX_TYPE);
    searchParams.delete(VERTEX_CONTEXT);
    searchParams.set(PAGE_PARAMETER, "1");
    searchParams.delete(VERTEX_SIMILARITY);
    searchParams.delete(AUTOMATIC_FLAT_RESPONSE_PARAMETER);
    setSearchParams(searchParams);
  };

  const handleSetVertex = useCallback(
    (threshold: string) => {
      searchParams.set(PAGE_PARAMETER, "1");
      searchParams.set(VERTEX_SIMILARITY, threshold);
      setSearchParams(searchParams);
    },
    [searchParams, setSearchParams],
  );

  if (!vertexCluster) {
    return <noscript />;
  }
  if (
    vertexType === "UPLOAD" &&
    vertexCluster.previews &&
    vertexCluster.previews.length > 0
  ) {
    return (
      <ImageFileCard
        filename={vertexCluster.previews[0].file_name}
        imageSrc={vertexCluster.previews[0].media_uri}
        imageThumbSrc={vertexCluster.previews[0].media_thumb_uri}
        cardElementRef={cardElementRef}
        onRemoveVertex={handleRemoveVertex}
        onSetVertexSimilarity={handleSetVertex}
      />
    );
  } else {
    return (
      <EnrichmentCard
        page={DATA_PAGE}
        key={index}
        index={index}
        isVertex={true}
        isDataPage={true}
        isVertexCard={true}
        isClusterPage={false}
        datasetId={datasetId!}
        showSelectOption={true}
        singleData={vertexCluster}
        globalMDType={globalMDType}
        cardElementRef={cardElementRef}
        containerRef={cardContainerRef}
        clusterID={vertexCluster.cluster_id}
        indexOfPointerOut={indexOfPointerOut}
        showMetadataSummary={showMetadataSummary}
        userTagsData={vertexCluster?.user_tags || []}
        //
        clusters={clusters}
        exportData={exportData}
        showDebugInfo={showDebugInfo}
        datasetLabels={datasetLabels}
        datasetUserTags={datasetUserTags}
        relevanceScores={relevanceScores}
        isCardslistLoading={isCardslistLoading}
        isNavigationClusterLoading={isNavigationClusterLoading}
        //
        onSelect={onSelect}
        onSetVertexSimilarity={handleSetVertex}
        onRemoveVertex={handleRemoveVertex}
        onIndexOfPointerOut={onIndexOfPointerOut}
        onGlobalMDTypeChange={onGlobalMDTypeChange}
      />
    );
  }
};

const mapStateToProps = (state: State) => {
  return {
    vertexCluster: getSimilarityVertexCluster(state),
  };
};
export default connect(mapStateToProps)(VertexCard);
